import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoading, selectUsers } from '../selectors/users.selector';
import { usersActions } from '../actions/users.actions';

@Injectable({
    providedIn: 'root',
})
export class UsersFacade {
    private store = inject(Store);

    readonly loading$ = this.store.select(selectLoading).pipe(filter((data) => data !== null));
    readonly users$ = this.store.select(selectUsers);

    getUsers(): void {
        this.store.dispatch(usersActions.getUsers());
    }

    clear(): void {
        this.store.dispatch(usersActions.clear());
    }
}
